<div class="mat-dialog-title">
  <p>{{ getTitle() }}</p>
</div>

<div class="mat-dialog-content">
  <p class="modal-text">{{ getText() }}</p>
</div>

<div class="mat-dialog-actions">
  <button mat-flat-button class="cancel-btn" (click)="closeDialog(false)">{{ getBtnBack() }}</button>

  <button mat-flat-button class="confirm-btn" (click)="emitConfirmEvent()">{{ getBtnOk() }}</button>
</div>
